interface SetCurrentScrollEventAction {
  type: 'SET_CURRENT_SCROLL_EVENT';
  eventId: string;
}

interface ClearCurrentScrollEventAction {
  type: 'CLEAR_CURRENT_SCROLL_EVENT';
}

export function setCurrentScrollEvent(eventId: string): SetCurrentScrollEventAction {
  return {
    type: 'SET_CURRENT_SCROLL_EVENT',
    eventId,
  };
}

export function clearCurrentScrollEvent(): ClearCurrentScrollEventAction {
  return { type: 'CLEAR_CURRENT_SCROLL_EVENT' };
}

export type CurrentScrollEventActionTypes =
  | SetCurrentScrollEventAction
  | ClearCurrentScrollEventAction;
